import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categorieSelected: null,
};

const categorieSlice = createSlice({
  name: "categorie",
  initialState,
  reducers: {
    setCategorieSelected: (state, action) => {
      state.categorieSelected = {
        event: action.payload.event,
        sport: action.payload.sport,
      };
    },
  },
});

export const { setCategorieSelected } = categorieSlice.actions;
export default categorieSlice.reducer;
